<div
  class="file-selection-dialog"
>
  <div class="dialog-title-bar">
    <h2 class="dialog-title" data-testid="specific-files-modal">Cancel Files</h2>
    <button
      type="button"
      class="close-btn"
      aria-label="Close dialog"
      (click)="onClose()"
      data-testid="specific-files-close"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
          fill="white"
        />
      </svg>
    </button>
  </div>

  <mat-dialog-content class="dialog-body" data-testid="file-selection-dialog">
    <p class="file-selection__subtitle">
      Please select which files you would like to cancel:
    </p>

    <div class="file-selection__groups">
      @if (languageGroups().length === 0) {
        <p class="file-selection__empty">No files available for cancellation.</p>
      } @else {
        @for (group of languageGroups(); track group.targetLanguageCode) {
          <mat-expansion-panel
            class="language-group"
            [expanded]="group.expanded"
            (opened)="setGroupExpanded(group, true)"
            (closed)="setGroupExpanded(group, false)"
            hideToggle
            [attr.data-testid]="'language-group-' + group.targetLanguageCode"
          >
            <mat-expansion-panel-header class="language-group__header">
              <mat-panel-title>
                <span class="language-header">
                  <span class="language-header__toggle" aria-hidden="true">
                    <svg
                      class="language-header__chevron"
                      [class.language-header__chevron--expanded]="group.expanded"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path d="M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z" fill="currentColor"/>
                    </svg>
                  </span>
                  <span class="language-header__name">{{ group.targetLanguageLabel }}</span>
                  <span
                    class="language-header__count"
                    [attr.data-testid]="'language-group-count-' + group.targetLanguageCode"
                  >
                    {{ getGroupSelectedCount(group) }}/{{ group.cancellableTotal }}
                  </span>
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="language-group__files">
              <div class="file-section file-section--eligible">
                @for (file of getEligibleFiles(group); track file.fileUid) {
                  <div
                    [ngClass]="getFileRowClass(file)"
                    [attr.data-testid]="'file-row-' + file.fileUid"
                  >
                    <div class="file-row__content" (click)="onFileRowClick(file)">
                      <mat-checkbox
                        class="file-row__checkbox"
                        [checked]="isFileSelected(file.fileUid)"
                        (change)="toggleFileSelection(file.fileUid, file.isCancellable)"
                        (click)="$event.stopPropagation()"
                        [attr.aria-label]="'Select ' + file.fileName"
                        [attr.data-testid]="'file-checkbox-' + file.fileUid"
                      ></mat-checkbox>
                      <span
                        class="file-row__name"
                        [class.file-row__name--disabled]="!file.isCancellable"
                        [class.file-row__name--cancelled]="file.isCancelled"
                      >
                        {{ file.fileName }}
                      </span>
                    </div>
                  </div>
                }
              </div>

              @if (getCompletedTranslationFiles(group).length > 0) {
                <div class="file-section__header">Completed Translations</div>
                <div class="file-section file-section--non-eligible">
                  @for (file of getCompletedTranslationFiles(group); track file.fileUid) {
                    <div
                      [ngClass]="getFileRowClass(file)"
                      [attr.data-testid]="'file-row-' + file.fileUid"
                    >
                      <div class="file-row__content">
                        <span
                          class="file-row__name"
                          [class.file-row__name--disabled]="!file.isCancellable"
                          [class.file-row__name--cancelled]="file.isCancelled"
                        >
                          {{ file.fileName }}
                        </span>
                      </div>
                    </div>
                  }
                </div>
              }

              @if (getAlreadyCancelledFiles(group).length > 0) {
                <div class="file-section__header">Already Cancelled</div>
                <div class="file-section file-section--non-eligible">
                  @for (file of getAlreadyCancelledFiles(group); track file.fileUid) {
                    <div
                      [ngClass]="getFileRowClass(file)"
                      [attr.data-testid]="'file-row-' + file.fileUid"
                    >
                      <div class="file-row__content">
                        <span
                          class="file-row__name"
                          [class.file-row__name--disabled]="!file.isCancellable"
                          [class.file-row__name--cancelled]="file.isCancelled"
                        >
                          {{ file.fileName }}
                        </span>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </mat-expansion-panel>
        }
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      type="button"
      class="btn btn-outline"
      (click)="onClose()"
      data-testid="specific-files-back"
    >
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="isContinueDisabled()"
      (click)="onContinue()"
      data-testid="specific-files-continue"
    >
      Confirm
    </button>
  </mat-dialog-actions>
</div>
